import { SessionProvider } from 'core/infrastructure';
import { Permission, Res } from 'core/api';
import { OrderingFacade } from 'pos/facades';
import { Message } from 'core/ui-next/modal';

async function canClaimTicketCreatedByOtherUser(creatorUser: string) {

	const session = SessionProvider.getCurrent();

	if (session.UserName === creatorUser)
		return true;

	if (!SessionProvider.hasPermission(Permission.Ticket_OpenCreatedByOtherUser)) {
		await Message.show(Res.Msg.MSG_PERMISSION_DENIED_FOR_OPEN_LOCATION_CREATED_BY_OTHER_USER(creatorUser));
		return false;
	}

	if (!session.WarnOnTicketCreatedByOtherUser)
		return true;

	const result = await Message.confirm(Res.Msg.MSG_LOCATION_IS_CREATED_BY_OTHER_USER(creatorUser));
	return result.ok;
}

async function canClaimTicketInUseByOtherUser(currentUser: string) {

	const session = SessionProvider.getCurrent();

	if (session.UserName === currentUser || currentUser === '')
		return true;

	if (!SessionProvider.hasPermission(Permission.Ticket_OpenInUseByOtherUser)) {
		await Message.show(Res.Msg.MSG_PERMISSION_DENIED_FOR_OPEN_LOCATION_IN_USE_BY_OTHER_USER(currentUser));
		return false;
	}

	if (!session.WarnOnTicketInUseByOtherUser)
		return true;

	const result = await Message.confirm(Res.Msg.MSG_LOCATION_IS_IN_USE_BY_OTHER_USER(currentUser));
	return result.ok;
}

async function canClaimTicketBlockedByOtherPos(blockerPos: string): Promise<boolean> {
	const session = SessionProvider.getCurrent();

	if (blockerPos === '' || blockerPos === session.PosName)
		return true;

	if (!SessionProvider.hasPermission(Permission.Ticket_OpenBlockedByOtherPos)) {
		await Message.show(Res.Msg.MSG_PERMISSION_DENIED_FOR_OPEN_LOCATION_BLOCKED_BY_OTHER_POS(blockerPos));
		return false;
	}

	const result = await Message.confirm(Res.Msg.MSG_LOCATION_IS_BLOCKED_BY_OTHER_USER(blockerPos));
	return result.ok;
}

export default async function userCanClaimTicket({ Id, OpenerUser, CurrentUser, BlockerPos }: { Id: number, OpenerUser: string, CurrentUser: string, BlockerPos: string }): Promise<boolean> {
	const canClaim = await canClaimTicketCreatedByOtherUser(OpenerUser)
		&& await canClaimTicketInUseByOtherUser(CurrentUser)
		&& await canClaimTicketBlockedByOtherPos(BlockerPos);

	// Si puedo quedarme con el ticket y estaba bloqueado, lo desbloqueo del pos que lo
	// tuviera (incluso si era este pos) porque voy a empezar a trabajar con él y ya no estoy
	// en una operación de pago (que es lo que habría dado lugar al bloqueo).
	if (canClaim && BlockerPos !== '')
		await OrderingFacade.unblockTicketByPos(Id, true);

	return canClaim;
}

